import React, { useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory, {
  PaginationProvider,
  SizePerPageDropdownStandalone,
  PaginationListStandalone,
} from 'react-bootstrap-table2-paginator'
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import Moment from 'react-moment'
import LoadingSpinner from '../../Shared/LoadingSpinner'
import useFetchingCompanyAudit from './useFetchingCompanyAudit'
import { useDispatch } from 'react-redux'
import { fetchCompanyAudit } from '../../actions/companyActions'

export const AuditTrail = (props) => {
  let [page, setPage] = useState(1)
  let [pageSize, setPageSize] = useState(10)

  let dispatch = useDispatch()
  let params = useParams()
  useFetchingCompanyAudit(params.companyId, page, pageSize)

  const handleTableChange = (type, rest) => {
    if (type === 'pagination') {
      setPage(rest.page)
      setPageSize(rest.sizePerPage)
      try {
        let searchFilter = rest.filters.description.filterVal
        dispatch(fetchCompanyAudit(params.companyId, false, rest.page, rest.sizePerPage, searchFilter))
      } catch {
        dispatch(fetchCompanyAudit(params.companyId, false, rest.page, rest.sizePerPage))
      }
    } else if (type === 'filter') {
      try {
        let searchFilter = rest.filters.description.filterVal
        dispatch(fetchCompanyAudit(params.companyId, false, rest.page, rest.sizePerPage, searchFilter))
      } catch {
        dispatch(fetchCompanyAudit(params.companyId, false, rest.page, rest.sizePerPage))
      }
    }
  }

  const dateFormatter = (cell) => {
    return <Moment format="DD/MM/YYYY hh:mmA">{cell}</Moment>
  }

  const defaultSorted = [
    {
      dataField: 'entered',
      order: 'desc',
    },
  ]

  const columns = [
    {
      dataField: 'id',
      text: 'Id',
      hidden: true,
    },
    {
      dataField: 'entered',
      text: 'Date',
      sort: false,
      formatter: dateFormatter,
      headerStyle: (column, colIndex) => {
        return { width: '185px' }
      },
    },
    {
      dataField: 'teamMember',
      text: 'Member',
      sort: false,
      hidden: true,
      // filter: textFilter({
      //   placeholder: 'Search',
      // }),
      headerStyle: (column, colIndex) => {
        return { width: '225px' }
      },
    },
    {
      dataField: 'description',
      text: 'Change',
      sort: false,
      filter: textFilter({
        placeholder: 'Search...',
      }),
      headerStyle: (column, colIndex) => {
        return { width: 'auto' }
      },
    },
  ]

  if (props.loading) {
    return <LoadingSpinner />
  } else if (props.selectedCompanyAudit) {
    return (
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          totalSize: props.selectedCompanyAuditCount,
          page: page,
          sizePerPage: pageSize,
          sizePerPageList: [
            { text: '10', value: 10 },
            { text: '20', value: 20 },
            { text: '50', value: 50 },
            { text: '100', value: 100 },
          ],
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            bootstrap4
            keyField="id"
            data={props.selectedCompanyAudit}
            columns={columns}
            selectedCompany={props.selectedCompany}
            exportCSV={{
              fileName: `${props.selectedCompany && props.selectedCompany.companyName}.csv`,
              onlyExportFiltered: true,
              exportAll: false,
            }}
          >
            {(props) => {
              return (
                <div>
                  <PaginationListStandalone {...paginationProps} />
                  <SizePerPageDropdownStandalone
                    btnContextual="btn-outline-primary"
                    className="dropDownStyle"
                    {...paginationProps}
                  />
                  <BootstrapTable
                    bordered={false}
                    keyField="id"
                    bootstrap4
                    filterPosition="top"
                    columns={columns}
                    defaultSorted={defaultSorted}
                    {...props.baseProps}
                    filter={filterFactory()}
                    loading={props.loading}
                    remote={{ pagination: true }}
                    onTableChange={handleTableChange}
                    {...paginationTableProps}
                  />
                </div>
              )
            }}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    )
  } else {
    return <div>No logs found</div>
  }
}

const mapStateToProps = (state) => ({
  loading: state.company.loadingAudit,
  selectedCompanyAudit: state.company.selectedCompanyAudit,
  selectedCompanyAuditCount: state.company.selectedCompanyAuditCount,
  selectedCompany: state.company.selectedCompany,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(AuditTrail)
